var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g2, _path1, _path10, _path11, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivitySetUpReleaseImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 62,
    viewBox: "0 0 135 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0985 19.0695V55.4946C27.0985 55.8577 27.027 56.2172 26.8879 56.5524C26.7489 56.8876 26.5452 57.1919 26.2885 57.4477C26.0318 57.7035 25.7272 57.9058 25.3923 58.0429C25.0574 58.18 24.6987 58.2493 24.337 58.2467H19.6037C20.5258 58.2467 21.4101 57.879 22.0621 57.2245C22.7142 56.57 23.0804 55.6823 23.0804 54.7568C23.0804 53.8311 22.7142 52.9435 22.0621 52.289C21.4101 51.6344 20.5258 51.2668 19.6037 51.2668H3.47672C2.55464 51.2668 1.67032 50.8991 1.0183 50.2446C0.366296 49.5901 0 48.7024 0 47.7769C0 46.8512 0.366296 45.9636 1.0183 45.3091C1.67032 44.6545 2.55464 44.2869 3.47672 44.2869H12.2877C13.2098 44.2869 14.0941 43.9192 14.7461 43.2647C15.3981 42.6102 15.7645 41.7225 15.7645 40.797C15.7645 39.8713 15.3981 38.9837 14.7461 38.3292C14.0941 37.6746 13.2098 37.307 12.2877 37.307H3.47672C2.55464 37.307 1.67032 36.9393 1.0183 36.2848C0.366296 35.6303 0 34.7426 0 33.817C0 32.8914 0.366296 32.0038 1.0183 31.3493C1.67032 30.6947 2.55464 30.3271 3.47672 30.3271H14.8257C15.7478 30.3271 16.6321 29.9594 17.2841 29.3049C17.9361 28.6504 18.3025 27.7627 18.3025 26.8371C18.3025 25.9115 17.9361 25.0239 17.2841 24.3694C16.6321 23.7148 15.7478 23.3472 14.8257 23.3472H8.25971C7.3376 23.3472 6.45329 22.9795 5.80128 22.325C5.14927 21.6705 4.78298 20.7828 4.78298 19.8572C4.78298 18.9316 5.14927 18.044 5.80128 17.3895C6.45329 16.7349 7.3376 16.3673 8.25971 16.3673H24.337C25.0591 16.3619 25.7541 16.6426 26.2711 17.1486C26.7882 17.6545 27.0855 18.3448 27.0985 19.0695Z",
    fill: "url(#paint0_linear_22205_9460)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.281 5.60833V41.4415C108.281 41.7973 108.351 42.1496 108.488 42.4783C108.624 42.8069 108.824 43.1055 109.076 43.3569C109.327 43.6082 109.625 43.8074 109.954 43.9431C110.283 44.0788 110.636 44.1484 110.991 44.1477H115.675C114.765 44.1477 113.893 43.7862 113.25 43.1426C112.606 42.499 112.245 41.6261 112.245 40.7159C112.245 39.8057 112.606 38.9328 113.25 38.2892C113.893 37.6456 114.765 37.2841 115.675 37.2841H131.57C132.48 37.2841 133.352 36.9225 133.996 36.2789C134.639 35.6354 135 34.7624 135 33.8523C135 32.9421 134.639 32.0692 133.996 31.4256C133.352 30.782 132.48 30.4204 131.57 30.4204H122.893C121.983 30.4204 121.111 30.0589 120.467 29.4153C119.824 28.7716 119.463 27.8988 119.463 26.9886C119.463 26.0784 119.824 25.2055 120.467 24.5619C121.111 23.9183 121.983 23.5568 122.893 23.5568H131.57C132.48 23.5568 133.352 23.1952 133.996 22.5516C134.639 21.908 135 21.0351 135 20.125C135 19.2148 134.639 18.3419 133.996 17.6983C133.352 17.0547 132.48 16.6931 131.57 16.6931H120.384C119.474 16.6931 118.602 16.3316 117.959 15.688C117.315 15.0443 116.954 14.1715 116.954 13.2613C116.954 12.3511 117.315 11.4783 117.959 10.8346C118.602 10.191 119.474 9.82948 120.384 9.82948H126.866C127.776 9.82948 128.648 9.46793 129.292 8.82432C129.935 8.1807 130.296 7.30785 130.296 6.39762C130.296 5.48748 129.935 4.61457 129.292 3.97098C128.648 3.32739 127.776 2.96583 126.866 2.96583H110.991C110.283 2.96435 109.604 3.24013 109.097 3.73408C108.591 4.22803 108.298 4.90084 108.281 5.60833Z",
    fill: "url(#paint1_linear_22205_9460)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.4547 0.980522H60.334C60.204 0.980522 60.0794 0.928871 59.9875 0.836927C59.8956 0.744991 59.844 0.620288 59.844 0.490265C59.844 0.360242 59.8956 0.235538 59.9875 0.143595C60.0794 0.0516585 60.204 0 60.334 0H64.44C64.5699 0 64.6946 0.0516585 64.7865 0.143595C64.8783 0.235538 64.93 0.360242 64.93 0.490265C64.93 0.620288 64.8783 0.744991 64.7865 0.836927C64.6946 0.928871 64.5699 0.980522 64.44 0.980522H64.4547Z",
    fill: "#35363A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.05 62.0082H31.0044C29.8156 62.003 28.6773 61.5272 27.8381 60.6848C26.9989 59.8424 26.5271 58.7019 26.5259 57.5125V4.4957C26.5272 3.30376 27.001 2.16102 27.8433 1.3182C28.6857 0.475371 29.8277 0.0013 31.019 0H56.4491C56.5791 0 56.7036 0.0516585 56.7955 0.143595C56.8874 0.235538 56.9391 0.360242 56.9391 0.490265C56.9391 0.620288 56.8874 0.744991 56.7955 0.836927C56.7036 0.928871 56.5791 0.980522 56.4491 0.980522H31.0044C30.0756 0.9857 29.1864 1.35818 28.5311 2.0167C27.8757 2.67522 27.5071 3.56635 27.5059 4.4957V57.5125C27.5071 58.4444 27.8777 59.3377 28.5363 59.9967C29.1948 60.6556 30.0877 61.0264 31.019 61.0277H61.0647C61.1947 61.0277 61.3193 61.0794 61.4112 61.1712C61.5031 61.2632 61.5547 61.3879 61.5547 61.5179C61.5547 61.6479 61.5031 61.7727 61.4112 61.8646C61.3193 61.9565 61.1947 62.0082 61.0647 62.0082H61.05Z",
    fill: "#35363A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2082 62.0078H63.8184C63.6884 62.0078 63.5638 61.9562 63.4719 61.8642C63.38 61.7723 63.3284 61.6476 63.3284 61.5176C63.3284 61.3876 63.38 61.2628 63.4719 61.1709C63.5638 61.079 63.6884 61.0273 63.8184 61.0273H69.2082C69.3381 61.0273 69.4628 61.079 69.5546 61.1709C69.6465 61.2628 69.6982 61.3876 69.6982 61.5176C69.6982 61.6476 69.6465 61.7723 69.5546 61.8642C69.4628 61.9562 69.3381 62.0078 69.2082 62.0078Z",
    fill: "#35363A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6771 62.0078H71.2754C71.1454 62.0078 71.0208 61.9562 70.9289 61.8642C70.837 61.7723 70.7854 61.6476 70.7854 61.5176C70.7854 61.3876 70.837 61.2628 70.9289 61.1709C71.0208 61.079 71.1454 61.0273 71.2754 61.0273H71.6771C71.8071 61.0273 71.9317 61.079 72.0236 61.1709C72.1155 61.2628 72.1671 61.3876 72.1671 61.5176C72.1671 61.6476 72.1155 61.7723 72.0236 61.8642C71.9317 61.9562 71.8071 62.0078 71.6771 62.0078Z",
    fill: "#35363A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.74 62.0077H74.0039C73.874 62.0077 73.7493 61.9561 73.6574 61.8641C73.5655 61.7722 73.5139 61.6475 73.5139 61.5174C73.5139 61.3874 73.5655 61.2627 73.6574 61.1708C73.7493 61.0788 73.874 61.0272 74.0039 61.0272H104.74C105.672 61.0272 106.566 60.6568 107.225 59.9976C107.883 59.3384 108.254 58.4443 108.254 57.512V29.3857C108.254 29.2557 108.305 29.131 108.397 29.0391C108.489 28.9471 108.613 28.8955 108.743 28.8955C108.873 28.8955 108.998 28.9471 109.09 29.0391C109.182 29.131 109.234 29.2557 109.234 29.3857V57.512C109.232 58.7039 108.758 59.8467 107.916 60.6895C107.073 61.5324 105.932 62.0064 104.74 62.0077Z",
    fill: "#35363A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.744 27.2395C108.614 27.2395 108.49 27.1879 108.398 27.0959C108.305 27.004 108.254 26.8793 108.254 26.7492V25.9747C108.254 25.8446 108.305 25.7199 108.398 25.628C108.49 25.536 108.614 25.4844 108.744 25.4844C108.874 25.4844 108.998 25.536 109.091 25.628C109.182 25.7199 109.234 25.8446 109.234 25.9747V26.7492C109.234 26.8793 109.182 27.004 109.091 27.0959C108.998 27.1879 108.874 27.2395 108.744 27.2395Z",
    fill: "#35363A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.744 23.8898C108.614 23.8898 108.49 23.8381 108.398 23.7462C108.305 23.6543 108.254 23.5295 108.254 23.3995V19.2715C108.254 19.1415 108.305 19.0168 108.398 18.9248C108.49 18.833 108.614 18.7812 108.744 18.7812C108.874 18.7812 108.998 18.833 109.091 18.9248C109.182 19.0168 109.234 19.1415 109.234 19.2715V23.3995C109.234 23.5295 109.182 23.6543 109.091 23.7462C108.998 23.8381 108.874 23.8898 108.744 23.8898Z",
    fill: "#35363A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.746 15.9384C108.616 15.9384 108.492 15.8868 108.399 15.7948C108.307 15.7028 108.256 15.5782 108.256 15.4481V4.49569C108.256 3.56341 107.885 2.66932 107.227 2.0101C106.568 1.35087 105.675 0.980522 104.742 0.980522H69.9883C69.8584 0.980522 69.7337 0.928871 69.6418 0.836927C69.5499 0.744991 69.4983 0.620287 69.4983 0.490265C69.4983 0.360242 69.5499 0.235538 69.6418 0.143595C69.7337 0.0516585 69.8584 0 69.9883 0H104.742C105.934 0.0013 107.076 0.475371 107.918 1.3182C108.76 2.16102 109.234 3.30376 109.236 4.49569V15.4481C109.236 15.5782 109.184 15.7028 109.093 15.7948C109 15.8868 108.876 15.9384 108.746 15.9384Z",
    fill: "#35363A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1944 0.980522H66.6016C66.4716 0.980522 66.347 0.928871 66.2551 0.836927C66.1632 0.744991 66.1116 0.620288 66.1116 0.490265C66.1116 0.360242 66.1632 0.235538 66.2551 0.143595C66.347 0.0516585 66.4716 0 66.6016 0H67.1944C67.3244 0 67.449 0.0516585 67.5409 0.143595C67.6328 0.235538 67.6844 0.360242 67.6844 0.490265C67.6844 0.620288 67.6328 0.744991 67.5409 0.836927C67.449 0.928871 67.3244 0.980522 67.1944 0.980522Z",
    fill: "#35363A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108.4 9.20277H27.4377C27.277 9.20277 27.1231 9.15862 27.0096 9.07997C26.8961 9.00132 26.8323 8.89472 26.8323 8.78348C26.8323 8.67231 26.8961 8.56564 27.0096 8.48706C27.1231 8.40841 27.277 8.36426 27.4377 8.36426H108.4C108.561 8.36426 108.715 8.40841 108.829 8.48706C108.942 8.56564 109.006 8.67231 109.006 8.78348C109.006 8.89472 108.942 9.00132 108.829 9.07997C108.715 9.15862 108.561 9.20277 108.4 9.20277Z",
    fill: "#35363A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22205_9460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 12,
    width: 17,
    height: 5,
    rx: 1,
    fill: "#C4BDD2"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7064 5.10918C31.5456 5.21575 31.3569 5.27259 31.1635 5.27259C30.9043 5.27259 30.6557 5.17046 30.4724 4.98869C30.289 4.80692 30.186 4.56039 30.186 4.30325C30.186 4.11151 30.2434 3.92419 30.3508 3.76475C30.4583 3.6053 30.611 3.48117 30.7895 3.4077C30.968 3.33439 31.1646 3.31523 31.3542 3.3526C31.5437 3.38997 31.7179 3.48228 31.8546 3.61781C31.9913 3.75335 32.0844 3.92609 32.1221 4.1142C32.1598 4.3023 32.1405 4.49706 32.0665 4.67423C31.9926 4.85141 31.8672 5.00262 31.7064 5.10918Z",
    fill: "#FF6058"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.716 5.10922C34.5553 5.21578 34.3662 5.27262 34.173 5.27262C34.0446 5.27262 33.9177 5.24761 33.799 5.19884C33.6805 5.15007 33.5726 5.07866 33.4819 4.98873C33.3912 4.89879 33.3192 4.79191 33.27 4.67427C33.2208 4.55662 33.1956 4.43059 33.1956 4.30329C33.1956 4.11154 33.2529 3.92423 33.3604 3.76478C33.4678 3.60534 33.6203 3.48104 33.799 3.40773C33.9776 3.33427 34.1741 3.31527 34.3637 3.35263C34.5532 3.39 34.7275 3.48231 34.8641 3.61785C35.0008 3.75338 35.0939 3.92629 35.1316 4.11423C35.1693 4.30234 35.15 4.49693 35.0761 4.67411C35.0021 4.85129 34.8768 5.00266 34.716 5.10922Z",
    fill: "#FFBD2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5696 5.10821C37.409 5.21477 37.2201 5.27161 37.0267 5.27161C36.8983 5.27161 36.7712 5.24659 36.6525 5.19783C36.5339 5.14906 36.4261 5.07765 36.3354 4.98771C36.2447 4.89778 36.1727 4.7909 36.1235 4.67326C36.0743 4.55561 36.0491 4.42958 36.0491 4.30227C36.0491 4.11053 36.1064 3.92322 36.2139 3.76377C36.3213 3.60433 36.474 3.48003 36.6525 3.40672C36.8311 3.33341 37.0276 3.31425 37.2172 3.35162C37.4067 3.38899 37.581 3.4813 37.7177 3.61684C37.8544 3.75237 37.9475 3.92512 37.9851 4.11306C38.0228 4.30117 38.0035 4.49592 37.9296 4.6731C37.8556 4.85028 37.7304 5.00165 37.5696 5.10821Z",
    fill: "#27C940"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22205_9460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 17,
    height: 5,
    rx: 2,
    fill: "#C4BDD2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_22205_9460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 19,
    width: 76,
    height: 6,
    rx: 1,
    fill: "#DAE9ED"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_22205_9460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 27,
    width: 76,
    height: 6,
    rx: 1,
    fill: "#C4BDD2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_22205_9460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 76,
    height: 6,
    rx: 1,
    fill: "#DAE9ED"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_22205_9460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 43,
    width: 76,
    height: 6,
    rx: 1,
    fill: "#C4BDD2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_22205_9460)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 51,
    width: 76,
    height: 6,
    rx: 1,
    fill: "#DAE9ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22205_9460",
    x1: 26.6058,
    y1: 37.5533,
    x2: -8.62226,
    y2: 37.5533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3F6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C6EBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22205_9460",
    x1: 109.626,
    y1: 22.2796,
    x2: 137.956,
    y2: 21.7869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3F6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C6EBFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22205_9460"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 12,
    width: 17,
    height: 5,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22205_9460"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 17,
    height: 5,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_22205_9460"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 19,
    width: 76,
    height: 6,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_22205_9460"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 27,
    width: 76,
    height: 6,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_22205_9460"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 76,
    height: 6,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_22205_9460"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 43,
    width: 76,
    height: 6,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_22205_9460"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 51,
    width: 76,
    height: 6,
    rx: 1,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySetUpReleaseImage);
export default __webpack_public_path__ + "static/media/activity_set_up_release_image.14baf341f93166337adfb0f087773c93.svg";
export { ForwardRef as ReactComponent };